"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Login =
/*#__PURE__*/
function (_Form) {
  _inherits(Login, _Form);

  function Login() {
    var _this;

    _classCallCheck(this, Login);

    var placeholder = new Placeholder({
      singleElement: true
    });

    var scope = function scope() {
      return _assertThisInitialized(_this);
    };

    return _this = _possibleConstructorReturn(this, _getPrototypeOf(Login).call(this, {
      formSelector: '#login-form',
      loadingClass: 'loading-svg',
      showSubmitAfterSuccess: false,
      resetOnSuccess: false,
      uinfo_iv: window.uinfo_iv,
      uinfo_key: window.uinfo_key,
      uinfo: true,
      successCallback: function successCallback() {
        // redirectURL foi recuperado no ASP.NET e setado no window
        // Aqui é necessário uma verificação para ver se a URL não é
        // uma URL externa, caso seja válida, redireciona para URL,
        // caso não seja válida, redireciona para o rootPath, que também
        // é setado no window pelo ASP.NET
        if (redirectURL != "" && Utils.url_isRedirectValid(redirectURL)) location.href = redirectURL;else location.href = rootPath;
      },
      failureCallback: function failureCallback(mensagem, json) {
        if (json.id == 'cadastro-nao-encontrado') Utils.modal_cadastroNaoEncontrado();else _this.showMessage(mensagem);
      }
    }));
  }

  _createClass(Login, [{
    key: "webforms_params",
    value: function webforms_params() {
      var params = _get(_getPrototypeOf(Login.prototype), "webforms_params", this).call(this);

      params.ajax = '/srv/v4/_ajax/frm-login.aspx?acao=enviar';
      params.xml = '/srv/v4/_xml/frm-login.xml';

      params.onBeforeSubmit = function () {
        if (!navigator.cookieEnabled) {
          modal('Os cookies de seu navegador est&atilde;o desativados.<br>' + 'Por favor, habilite os cookies para continuar.');
          return false;
        }

        return true;
      };

      return params;
    }
  }]);

  return Login;
}(Form);